import en from 'i18n/prioritised_outcome.en.json'
import nb from 'i18n/prioritised_outcome.nb.json'

export const PRODUCTIVITY_FIELD = 'productivity'
export const TURNOVER_FIELD = 'turnover'
export const SICKNESS_ABSENCE_FIELD = 'absence'
export const NO_PRIORITY_FIELD = 'noPriority'

const languages = { en, nb }

type OutcomeCategory = { description: string[]; label: string }
type OutcomeCategories = Record<string, [string[], string]>
type PrioritisedOutcomeField = { description: string[]; name: string }

const languageCategories: Record<
  string,
  Record<string, OutcomeCategory>
> = languages

export const categoryNames = (language = 'en'): OutcomeCategories =>
  Object.fromEntries(
    Object.entries(languageCategories[language] ?? {}).map(([name, value]) => [
      name,
      [value.description, value.label],
    ]),
  )

const getCategories = (values: OutcomeCategories) => [
  ...new Set(Object.values(values).map(([_description, label]) => label)),
]

const getPrioritisedOutcomes = (values: OutcomeCategories) =>
  Object.entries(values)
    .map(([name, [description, label]]) => ({
      description,
      name,
      label,
    }))
    .reduce((grouped, { description, name, label }) => {
      grouped[label] = {
        ...(grouped[label] ?? {}),
        description,
        name,
      }

      return grouped
    }, {})

export const getOutcomeOrder = language => {
  const [first, second, third] = getCategories(categoryNames(language))

  return [third, second, first]
}

export const getFields = (language): Record<string, PrioritisedOutcomeField> =>
  getPrioritisedOutcomes(categoryNames(language)) as Record<
    string,
    PrioritisedOutcomeField
  >

export const getDefaultValues = () => ({
  [NO_PRIORITY_FIELD]: true,
  [PRODUCTIVITY_FIELD]: false,
  [SICKNESS_ABSENCE_FIELD]: false,
  [TURNOVER_FIELD]: false,
})
